import React, { useState } from "react";
import Hero from "../components/Hero";
import Memberships from "../components/Memberships";
import "./MembershipsPage.css";

const MEMBERSHIP_BENEFITS_LEAD =
  "Except the fact that you will participate in and contribute towards building a more socially and environmentally sustainable food system";

const MembershipsPage = () => {
  const [isBenefitsExpanded, setIsBenefitsExpanded] = useState(false);

  return (
    <>
      <Hero page={"memberships"} titleTwo={"Memberships"} />

      <div className="hero-introduction-wrapper csa-extra-space">
        <div className="hero-introduction-container">
          <div className="hero-introduction">
            <p>
              If you want to participate in and contribute towards building a
              more socially and environmentally sustainable food system,
              becoming a member of Alnarp’s Farm is a great opportunity to do
              so.
            </p>
          </div>
        </div>
      </div>
      <section className="content-container">
        <div className="info-card green membership-info-card">
          <h3>Why become a member?</h3>
          <p className="membership-benefits-text">
            <span className="membership-benefits-lead">
              {MEMBERSHIP_BENEFITS_LEAD}
            </span>
            {!isBenefitsExpanded && (
              <span className="membership-benefits-mobile-toggle">
                <span
                  className="membership-benefits-ellipsis"
                  aria-hidden="true"
                >
                  …
                </span>
                <button
                  type="button"
                  className="membership-benefits-toggle-btn"
                  onClick={() => setIsBenefitsExpanded(true)}
                >
                  Read more
                </button>
              </span>
            )}
            <span
              className={
                isBenefitsExpanded
                  ? "membership-benefits-rest is-expanded"
                  : "membership-benefits-rest"
              }
            >
              , as a member, you have the right to attend our Annual General
              Meetings and vote on important matters such as our budget
              allocation and seasonal planning. You will also receive{" "}
              <strong style={{ color: "var(--green-700)" }}>
                exclusive invitations to events and priority notice of workshops
              </strong>{" "}
              organised by the farm. If you aren’t able to work on the farm but
              still want to be involved somehow, membership is a great option
              for you.{" "}
              {isBenefitsExpanded && (
                <button
                  type="button"
                  className="membership-benefits-toggle-btn membership-benefits-read-less"
                  onClick={() => setIsBenefitsExpanded(false)}
                >
                  Read less
                </button>
              )}
            </span>
          </p>
        </div>
        <Memberships />
      </section>
    </>
  );
};

export default MembershipsPage;
